import axios from "axios";

export const URL = "https://api.woodengifts.in";
export const axiosInstance = axios.create({
  baseURL: URL,
});

export const dashboard = async () => {
  const response = await axios.get(`${URL}/admin/dashboard`);
  return response.data;
};

export const login = async (data) => {
  const { data: res } = await axios.post(`${URL}/admin/login`, data);
  return res;
};

export const getAllCategories = async () => {
  const { data } = await axios.get(`${URL}/admin/categories`);
  return data;
};

export const getAllPaginatedCategories = async (page, search) => {
  const { data } = await axios.get(
    `${URL}/admin/categories?page=${page}&search=${search}&limit=20`
  );
  return data;
};

export const deleteCategories = async (id) => {
  const { data } = await axios.delete(`${URL}/admin/category/${id}`);
  return data;
};

export const addCategory = async (data) => {
  const { data: res } = await axios.post(`${URL}/admin/category`, data);
  return res;
};

export const getCategoryById = async (id) => {
  const { data } = await axios.get(`${URL}/admin/category/${id}`);
  return data;
};
export const getVendorOrderById = async (id, status) => {
  const { data } = await axios.get(
    `${URL}/admin/vendor-orders/${id}?page=1&limit=50&orderStatus=${status}`
  );
  return data;
};
export const getUserOrders = async (id, status, startDate, endDate) => {
  const { data } = await axios.get(
    `${URL}/admin/orders?page=1&limit=50&orderStatus=${status}${
      startDate ? `&startDate=${startDate}` : ""
    }${endDate ? `&endDate=${endDate}` : ""}`
  );
  return data;
};

export const updateCategory = async (id, data) => {
  const { data: res } = await axios.put(`${URL}/admin/category/${id}`, data);
  return res;
};

export const getAllSubCategoriesByCategory = async (id) => {
  const { data } = await axios.get(`${URL}/admin/subcategories/${id}`);
  return data;
};

export const deleteSubCategories = async (id) => {
  const { data } = await axios.delete(`${URL}/admin/subcategory/${id}`);
  return data;
};

export const addSubCategory = async (data) => {
  const { data: res } = await axios.post(`${URL}/admin/subcategory`, data);
  return res;
};

export const getSubCategoryById = async (id) => {
  const { data } = await axios.get(`${URL}/admin/subcategory/${id}`);
  return data;
};

export const updateSubCategory = async (id, data) => {
  const { data: res } = await axios.put(`${URL}/admin/subcategory/${id}`, data);
  return res;
};

export const updateSystemValues = async (data) => {
  const { data: res } = await axios.put(`${URL}/admin/system-values`, data);
  return res;
};

export const addAdmin = async (data2) => {
  const { data } = await axios.post(`${URL}/admin/signup`, data2);
  return data;
};
export const getAllAdmins = async () => {
  const { data: res } = await axios.get(`${URL}/admin/all-admins`);
  return res;
};
export const deleteAdmin = async (id) => {
  const { data: res } = await axios.delete(`${URL}/admin/delete-admin/${id}`);
  return res;
};

export const updateAdmin = async (data, id) => {
  const response = await axios.put(`${URL}/admin/admin-update/${id}`, data);
  return response.data;
};

export const getBanner = async (location) => {
  const { data: res } = await axios.get(
    `${URL}/admin/banners?location=${location}`
  );
  return res;
};

export const getProducts = async (page, search, searchType) => {
  const { data: res } = await axios.get(
    `${URL}/admin/products?page=${page}&search=${search}&searchType=${searchType}&limit=20`
  );
  return res;
};

export const addProduct = async (data) => {
  const response = await axios.post(`${URL}/admin/product`, data);
  return response.data;
};

export const deleteProduct = async (id) => {
  const response = await axios.delete(`${URL}/admin/product/${id}`);
  return response.data;
};

export const updateProduct = async (id, data) => {
  const response = await axios.put(`${URL}/admin/product/${id}`, data);
  return response.data;
};

export const updateBanner = async (id, data) => {
  const response = await axios.put(`${URL}/admin/banner/${id}`, data);
  return response.data;
};

export const getProductQuantityById = async (id) => {
  const { data } = await axios.get(`${URL}/admin/product-quantity/${id}`);
  return data;
};

export const addBanner = async (data) => {
  const response = await axios.post(`${URL}/admin/banner`, data);
  return response.data;
};

export const deleteBanner = async (id) => {
  const response = await axios.delete(`${URL}/admin/banner/${id}`);
  return response.data;
};

export const addQuantity = async (data) => {
  const response = await axios.post(`${URL}/admin/product-quantity`, data);
  return response.data;
};

export const updateQuantity = async (id, data) => {
  const response = await axios.put(`${URL}/admin/product-quantity/${id}`, data);
  return response.data;
};

export const deleteQuantity = async (id) => {
  const response = await axios.delete(`${URL}/admin/product-quantity/${id}`);
  return response.data;
};

export const getProductById = async (id) => {
  const { data } = await axios.get(`${URL}/admin/product/${id}`);
  return data;
};

export const getBrand = async () => {
  const { data: res } = await axios.get(`${URL}/admin/brands`);
  return res;
};

export const addBrand = async (data) => {
  const { data: res } = await axios.post(`${URL}/admin/brand`, data);
  return res;
};

export const deleteBrand = async (id) => {
  const { data: res } = await axios.delete(`${URL}/admin/brand/${id}`);
  return res;
};

export const updateBrand = async (id, data) => {
  const { data: res } = await axios.put(`${URL}/admin/brand/${id}`, data);
  return res;
};

export const getVendors = async (search, page) => {
  const { data: res } = await axios.get(
    `${URL}/admin/vendors?page=${page}&limit=100&search=${search}`
  );
  return res;
};

export const getUsers = async (search, page) => {
  const { data: res } = await axios.get(
    `${URL}/admin/users?page=${page}&limit=100&search=${search}`
  );
  return res;
};

export const getVendorById = async (id) => {
  const { data } = await axios.get(`${URL}/admin/vendor/${id}`);
  return data;
};

export const updateVendor = async (id, data) => {
  const { data: res } = await axios.put(`${URL}/admin/vendor/${id}`, data);
  return res;
};

export const deleteVendor = async (id) => {
  const { data: res } = await axios.delete(`${URL}/admin/vendor/${id}`);
  return res;
};

export const addVendor = async (data) => {
  const { data: res } = await axios.post(`${URL}/admin/vendor`, data);
  return res;
};

export const getAllSubCategories = async (page, search) => {
  const { data } = await axios.get(
    `${URL}/admin/all-subcategories?page=${page}&search=${search}&limit=20`
  );
  return data;
};

export const addUser = async (data) => {
  const { data: res } = await axios.post(`${URL}/admin/user`, data);
  return res;
};

export const updateUser = async (id, data) => {
  const { data: res } = await axios.put(`${URL}/admin/user/${id}`, data);
  return res;
};

export const deleteUser = async (id) => {
  const { data: res } = await axios.delete(`${URL}/admin/user/${id}`);
  return res;
};

export const getRedemptionRequests = async () => {
  const { data: res } = await axios.get(`${URL}/admin/redeem-requests`);
  return res;
};

export const updateRequestStatus = async ({ id, status }) => {
  const { data: res } = await axios.put(`${URL}/admin/redeem-request/${id}`, {
    status,
  });
  return res;
};

export const addDeliveryPerson = async (data) => {
  const { data: res } = await axios.post(`${URL}/admin/deliveryperson`, data);
  return res;
};

export const deleteDeliveryPerson = async (id) => {
  const { data: res } = await axios.delete(`${URL}/admin/deliveryperson/${id}`);
  return res;
};

export const getDeliveryPersons = async (page = 1, limit = 100) => {
  const { data: res } = await axios.get(
    `${URL}/admin/deliverypersons?page=${page}&limit=${limit}`
  );
  return res;
};

export const updateDeliveryPerson = async (id, data) => {
  const { data: res } = await axios.put(
    `${URL}/admin/deliveryperson/${id}`,
    data
  );
  return res;
};

export const getEarnings = async (page, startDate, endDate) => {
  const { data: res } = await axios.get(
    `${URL}/admin/earnings?page=${page}&limit=10${
      startDate ? `&startDate=${startDate}` : ""
    }${endDate ? `&endDate=${endDate}` : ""}`
  );
  return res;
};

export const getWalletForVendor = async (id) => {
  const { data: res } = await axios.get(`${URL}/admin/vendor-wallet/${id}`);
  return res;
};

export const getFiltersByCategory = async (categoryId) => {
  const response = await axiosInstance.get(`/admin/filters/${categoryId}`);
  return response.data;
};

export const addFilter = async (data) => {
  const response = await axiosInstance.post("/admin/filter", data);
  return response.data;
};

export const updateFilter = async (id, data) => {
  const response = await axiosInstance.put(`/admin/filter/${id}`, data);
  return response.data;
};

export const deleteFilter = async (id) => {
  const response = await axiosInstance.delete(`/admin/filter/${id}`);
  return response.data;
};
